module.exports = __webpack_public_path__ + "ico-crypto-matic.svg?1087d3d671ac2ca5eeea49c18e1175bf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ico-crypto-matic.svg
// module id = 1159
// module chunks = 2